XPortal.GridSizing = (function () {
    const self = {
        isGridVisible: function (gridEl) {
            const gridInfo = XPortal.Grid.GetGridInfo(gridEl);
            return gridInfo.parent.length && gridInfo.parent.is(':visible');
        },

        getDefaultMinHeight: function (gridEl) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            return $popupWrapper.length ? 155 : 304;
        },

        calculateGridHeight: function (gridEl, gridInfo, defaultMinHeight) {
            const element = self.findGridElement(gridEl);
            const elementPosition = XPortal.Utils.getPosition(element[0]);
            const $sectionWrapper = gridEl.closest('.xsection');
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $popupDetailWrapper = gridEl.closest('.extended-popup-box .modal-body');
            const windowHeight = document.documentElement.clientHeight;
            const pageFooterHeight = $('.footer').outerHeight();
            let gridHeight = 0;
            //console.log('start calc for: - grid height recalc - ' + gridInfo.nodeId);
            if ($popupWrapper.length) {
                gridHeight = self.calculatePopupGridHeight($popupWrapper);
            } else {
                const base = windowHeight - elementPosition.top - pageFooterHeight - 4;
                const hasRemoveMargin = $sectionWrapper.length && $sectionWrapper.is('.remove-margin-bottom');
                gridHeight = base - (hasRemoveMargin ? 0 : 12);
            }
            if($popupDetailWrapper.length) {
                gridHeight = self.calculatePopupDetailGridHeight($popupDetailWrapper);
            }

            if ($sectionWrapper.length && $sectionWrapper.hasClass('maximized')) {
                gridHeight = self.calculateMaximizedSectionGridHeight($sectionWrapper, gridInfo);
            } else {
                gridHeight = self.calculateRegularGridHeight(gridInfo, gridHeight);
            }

            gridHeight = self.applyStaticHeight(gridEl, gridHeight);
            gridHeight = self.adjustGridHeight(gridEl, gridInfo, gridHeight, defaultMinHeight);
            return Math.max(gridHeight, defaultMinHeight);
        },

        findGridElement: function (gridEl) {
            let element = gridEl.filter(':visible').length ? gridEl : gridEl.next('.entity-list');
            if (!element.length) {
                element = gridEl.closest('.k-pane-wrapper').next('.entity-list');
            }
            return element;
        },

        calculatePopupGridHeight: function ($popupWrapper) {
            const contentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-content:visible'));
            const smallContentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-small-content:visible'));
            return $popupWrapper.outerHeight() - contentHeight - smallContentHeight;
        },

        calculatePopupDetailGridHeight: function ($popupDetailWrapper) {
            const gridHeaderHeight = self.getElementOuterHeight($popupDetailWrapper.find('.grid-action-header'));
            return $popupDetailWrapper.height() - gridHeaderHeight; 
        },

        calculateMaximizedSectionGridHeight: function ($sectionWrapper, gridInfo) {
            const $sectionBgwrapper = $sectionWrapper.find('>.xbgdecoration-wrap');
            const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
            const gridHeaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            return $sectionWrapper.height() - self.GetElementVarticalOffset($sectionBgwrapper[0]) - blockHeaderHeight - gridHeaderHeight - 16;
        },

        calculateRegularGridHeight: function (gridInfo, gridHeight) {
            const $gridParent = gridInfo.parent;
            const $sectionContentOfGridParent = $gridParent.parent();
            const $gridParentHeightAttr = parseInt($gridParent.attr('data-height')) || 0;
            const $sectionContentOfGridParentHeightAttr = parseInt($sectionContentOfGridParent.attr('data-height')) || 0;
            const heightAttr = Math.max($gridParentHeightAttr, $sectionContentOfGridParentHeightAttr);
            const isHeightAttrValid = heightAttr > 0;
            const gridheaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header')) + 2;
            return isHeightAttrValid ? heightAttr - gridheaderHeight : gridHeight;
        },

        applyStaticHeight: function (gridEl, gridHeight) {
            const gridStaticHeightAttr = gridEl.parent('.grid-parent').attr('data-static-height');
            if (gridStaticHeightAttr >= 0) {
                gridHeight = Number(gridStaticHeightAttr);
            }
            return gridHeight;
        },

        adjustGridHeight: function (gridEl, gridInfo, gridHeight, defaultMinHeight) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');

            let finalHeight = gridHeight;

            if (!isSectionMaximized) {
                finalHeight = self.adjustRegularGridHeight(gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo, $popupWrapper);
            }

            finalHeight = self.adjustHeightForSiblingSections(gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo);

            if (window.innerWidth <= 768) {
                finalHeight = self.calculatePixelsFromVh('60vh');
            }

            finalHeight = self.applyStaticHeight(gridEl, finalHeight);
            return finalHeight;
        },

        calculatePixelsFromVh: function (vh) {
            const val = parseFloat(vh);
            if (isNaN(val)) return 0;
            return Math.floor((val * window.innerHeight) / 100);
        },

        adjustRegularGridHeight: function (gridEl, $sectionWrapper, gridHeight, defaultMinHeight, gridInfo, $popupWrapper) {
            const $halfSizeSection = gridEl.closest('.half-size-grid');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
            let finalHeight = gridHeight;
            if ($halfSizeSection.length) {
                const $nextSectionWrapper = gridInfo.parent.next('.xsection.col-12');
                const pageFooterHeight = $('.footer').outerHeight();
                let sectionHeaderHeight = self.getElementOuterHeight($halfSizeSection.find('>.xbgdecoration-wrap>.block-header'));
                const halfSizeSectionOffset = self.GetElementVarticalOffset($halfSizeSection[0]) + 2 + self.GetElementVarticalOffset($nextSectionWrapper[0]);
                const $gridActionHeader = $halfSizeSection.find('.grid-action-header');
                const gridActionHeaderHeigth = self.getElementOuterHeight($gridActionHeader);
                sectionHeaderHeight += gridActionHeaderHeigth;
                finalHeight = self.calculateHalfSizeGridHeight(gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset);
            } else {

                const sctSttgsHgt = (XPortal.SectionBlock.getOptions($sectionWrapper) || {}).Height || {};
                const lstExtraHgt = gridInfo.list.is(':visible') && !gridInfo.grid.is(':visible') ? 1 : 0;
                const gszExact = Math.min(sctSttgsHgt.Max || 99999, sctSttgsHgt.Exact || 99999);
                if (gszExact > 0 && gszExact < 99999) {
                    const cheight = gszExact;
                    //console.log('----grid height recalc - ' + gridInfo.nodeId + 'cntr=' + cheight + ',hdr=' + headerHeight + ',ftr=' + footerHeight, { sctSttgsHgt, lstExtraHgt, stack: new Error().stack });
                    if (cheight > 0)
                        return finalHeight = cheight - headerHeight - footerHeight - lstExtraHgt;
                }

                if (finalHeight < defaultMinHeight) {
                    finalHeight = defaultMinHeight;
                }
            }

            return finalHeight;
        },

        calculateHalfSizeGridHeight: function (gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset) {
            const windowHeight = $(window).height();
            const contentWrapperOffset = self.GetElementVarticalOffset($('.content-wrapper')[0]);

            if (window.matchMedia('(min-width: 1024px)').matches || (window.matchMedia('(orientation: portrait)').matches && window.matchMedia('(max-width: 1023.98px)').matches)) {
                return (windowHeight - headerHeight - pageFooterHeight - contentWrapperOffset) / 2 - sectionHeaderHeight - halfSizeSectionOffset;
            }
            if (window.matchMedia('(max-width: 767px)').matches) {
                return $(window).height() / 2 - 2 * headerHeight - pageFooterHeight - contentWrapperOffset;
            }
            return gridHeight;
        },

        adjustHeightForSiblingSections: function (gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo) {
            const $sectionSiblings = $sectionWrapper.siblings();
            if ($sectionSiblings.length > 0 && XPortal.Utils.getPosition($sectionSiblings[0]).top === XPortal.Utils.getPosition($sectionWrapper[0]).top) {
                const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
                const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
                const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
                const blockHeaderOffset = blockHeaderHeight > 0 ? 16 : 0;
                const sectionWrapperOffset = $sectionWrapper.hasClass('remove-paddings') ? 2 : 34;
                gridEl.closest('.grid-parent').css('margin-bottom', $sectionSiblings.find('.comments-wrap').length ? '1rem' : 0);
                finalHeight = $sectionSiblings.height() - headerHeight - footerHeight - blockHeaderHeight - blockHeaderOffset - sectionWrapperOffset;

                if ($sectionWrapper.parents().is('.tab-content') && $sectionSiblings.find('.filter-set-summary__items')) {
                    finalHeight = $(window).height() - XPortal.Utils.getPosition(gridEl.closest('.xsection')[0]).top - $('.footer').outerHeight();
                    const gridBlockHeaderHeight = self.getElementOuterHeight(gridEl.closest('.xbgdecoration-wrap').find('> .block-header'));
                    const gridSectionPaddingsOffset = self.GetElementVarticalOffset(gridEl.closest('.xsection').find('>.xbgdecoration-wrap')[0]) + self.GetElementVarticalOffset(gridEl.closest('.xsection')[0]);

                    const headerSiblingHeight = self.getElementOuterHeight($sectionSiblings.find('> .xbgdecoration-wrap > .block-header'));
                    const ssSiblingPaddingsOffset = $sectionSiblings.hasClass('remove-paddings') ? 16 : 32;
                    const siblingFilterButtonHeight = self.getElementOuterHeight($sectionSiblings.find('.dynamic-filter-button-wrp'));
                    const totalSiblingFilterHeight = finalHeight - headerSiblingHeight - ssSiblingPaddingsOffset - siblingFilterButtonHeight;
                    $sectionSiblings
                        .find(".filter-set-summary__items")
                        .css({ height: totalSiblingFilterHeight, overflow: "auto" })
                        .addClass("custom-scroll-vertical")
                        .removeClass("h-100");

                    $sectionSiblings.each(function () {
                        const $siblingSectionInTab = $(this);
                        const siblingsBlockHeaderHeight = self.getElementOuterHeight($siblingSectionInTab.find('> .xbgdecoration-wrap > .block-header'));
                        const siblingSectionInTabHeaderHeight = siblingsBlockHeaderHeight ? 0 : gridBlockHeaderHeight;
                        const ssMainSummaryHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-summary_main'));
                        const ssMainFilterButtonHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-button-wrp'));
                        const ssMainFiltersHeader = self.getElementOuterHeight($siblingSectionInTab.find('.filter-set-summary__header'));
                        const ssGridSectionPaddingsOffset = $siblingSectionInTab.hasClass('remove-paddings') ? 16 : 32;
                        const ssTotalFiltersHeight = finalHeight - ssMainFiltersHeader - ssMainSummaryHeight - ssMainFilterButtonHeight - ssGridSectionPaddingsOffset + headerHeight + siblingSectionInTabHeaderHeight + gridSectionPaddingsOffset;

                        $siblingSectionInTab.find('.filter-set-summary__items')
                            .css({ 'height': ssTotalFiltersHeight, 'overflow': 'auto' })
                            .addClass('custom-scroll-vertical')
                            .removeClass('h-100');
                    }.bind(this));
                }
            }
            return finalHeight;
        },

        getElementOuterHeight: function ($element) {
            return $element.length > 0 ? $element.outerHeight() : 0;
        },

        getHiddenElementHeight: function (element) {
            const clonedElement = element.cloneNode(true);
            clonedElement.style.visibility = 'hidden';
            clonedElement.style.position = 'absolute';
            document.body.appendChild(clonedElement);
            const height = clonedElement.offsetHeight;
            document.body.removeChild(clonedElement);
            return height;
        },

        setGridHeight: function (gridEl, gridHeight) {
            gridEl.css('height', gridHeight);
        },

        adjustListViewHeight: function (gridEl, gridHeight) {
            let $listView = gridEl.next('.entity-list');
            if (!$listView.length) {
                $listView = gridEl.closest('.k-pane-wrapper').next('.entity-list');
            }
            const $listPager = $listView.find('.k-listview-pager');
            if ($listView.length) {
                const $listContent = $listView.find('.k-listview-content');
                const footerHeight = $listView.is('[data-hide-footer="True"]') ? 0 : ($listPager.length ? $listPager.outerHeight() : 0);
                const availableHeight = gridHeight - footerHeight;
                $listContent.css({
                    'max-height': availableHeight + 'px',
                    'overflow-y': 'auto'
                });
                requestAnimationFrame(() => {
                    const hasActiveScroll = $listContent[0] ? ($listContent[0].scrollHeight > $listContent[0].clientHeight) : false;
                    if (hasActiveScroll) {
                        $listContent.addClass('with-scroll').removeClass('no-scroll');
                        $listContent.css('padding-right', '0px');
                    } else {
                        $listContent.addClass('no-scroll').removeClass('with-scroll');
                        $listContent.css('padding-right', '');
                    }
                });
                $listView.css('height', gridHeight);
            }
        },

        adjustParentHeight: function (gridEl, gridInfo, gridHeight) {
            const $filters = gridInfo.parent.find('.filters-list-wrapper.static');
            const filtersHeight = $filters.length && $filters.is(':visible') ? $filters.outerHeight(true) : 0;
            const parentHeight = gridHeight + filtersHeight;
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));

            if (!isSectionMaximized) {
                gridInfo.parent.css('height', ($popupWrapper.length ? parentHeight : parentHeight + headerHeight));
            } else {
                gridInfo.parent.css('height', parentHeight + headerHeight);
            }
        },

        adjustSectionContentHeight: function (gridEl) {
            const $sectionWrapper = gridEl.closest('.xsection');
            if ($sectionWrapper.length) {
                $sectionWrapper.children('.section-content').children('.xcontent').css({
                    'min-height': '',
                    'height': ''
                });
            }
        },

        resizeKGrid: function (gridInfo) {
            if (gridInfo.kgrid) {
                gridInfo.kgrid.resize();
            }
        },

        adjustGridHeaderHeight: function (gridEl) {
            setTimeout(function () {
                if (!gridEl.hasClass('height-resized')) {
                    let gridHeightDiv = 0;
                    const gridHeaderHide = gridEl.data('hide-grid-header') === 'True';
                    if (gridHeaderHide) {
                        const $groupingHeader = gridEl.find('.k-grouping-header');
                        if ($groupingHeader.length) {
                            gridHeightDiv += $groupingHeader.outerHeight();
                        }
                        if (gridEl.closest('.k-pane-wrapper').length) {
                            gridHeightDiv -= 17;
                        }
                        const $gridContent = gridEl.find('.k-grid-content');
                        const $gridContentLocked = gridEl.find('.k-grid-content-locked');
                        $gridContent.height($gridContent.height() + gridHeightDiv);
                        $gridContentLocked.height($gridContentLocked.height() + gridHeightDiv);
                    }
                    gridEl.addClass('height-resized');
                    setTimeout(function () {
                        gridEl.removeClass('height-resized');
                    }, 120);
                }
            }, 100);
        },

        adjustRelatedSections: function (gridEl, gridInfo) {
            const gridElId = gridEl.data('id');
            const $relatedSections = $(`[data-parentid="${gridElId}"]`);
            setTimeout(function () {
                $relatedSections.each(function () {
                    const $relatedSectionEl = $(this);
                    self.AdjustRelatedSectionsHeight($relatedSectionEl, gridEl, gridInfo);
                });
            }, 200);
        },

        setInitialHeight: function ($element) {
            $element.css({ 'height': 'initial', 'overflow': 'initial' })
                .removeClass('custom-scroll-vertical')
                .removeClass('h-100');
        },

        setElementHeight: function ($element, height) {
            $element.css({ 'height': height })
                .addClass('custom-scroll-vertical')
                .removeClass('h-100');
        },

        AdjustRelatedSectionsHeight: function ($relatedSection, gridEl, ginfo) {
            const $currentSection = $relatedSection;

            //detail page case (Quick preview)
            const $detail = $currentSection.find('.section-content .detailblock-viewcontainer');
            if ($detail) {
                const mainGridSectionHeight = gridEl.parents('.grid-parent').outerHeight() || 0;
                const detailHeaderHeight = $currentSection.find('.block-header').outerHeight() || 3;
                const detailPaddings = $currentSection.hasClass('remove-paddings') ? 0 : 35;
                const sectionTopPadding = parseFloat($currentSection.find('.section-content').css('padding-top')) || 0;
                const detailPageHeight = mainGridSectionHeight - detailHeaderHeight - detailPaddings - sectionTopPadding;
                $detail.css({ 'height': detailPageHeight, 'overflow': 'auto' })
                    .addClass('custom-scroll-vertical')
                    .removeClass('h-100');
            }

            const notAdjust = $currentSection.hasClass('col-12') || $currentSection.find('.xmapviewblock').length > 0;
            if (notAdjust) return;
            const withTabs = $currentSection.find('.nav-tabs').length > 0;
            const tabPane = $currentSection.find('.tab-pane');
            if (tabPane.attr('data-minheight') || tabPane.attr('data-height') || tabPane.attr('data-maxheight')) return;
            const $mainGridSection = gridEl.parents('.grid-parent');
            const isMobileWindow = $(window).width() < 576;
            if ($mainGridSection.hasClass('col-12') && isMobileWindow) return
            let mainGridSectionHeight = gridEl.parents('.grid-parent').outerHeight();
            const topHeaderHeight = self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header'));
            const desriptionHeight = self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header-description'));
            const sectionHeaderHeight = topHeaderHeight + desriptionHeight;
            const $sectionHeightContainer = $currentSection.closest('[data-height]');
            const heightAttr = $sectionHeightContainer.length ? $sectionHeightContainer.attr('data-height') : undefined;
            const withRelatedGrid = $currentSection.find('.grid-parent').length > 0;
            const sectionPaddingsOffset = self.GetElementVarticalOffset($currentSection.find('>.xbgdecoration-wrap')[0]);
            const isCollapsed = $currentSection.hasClass('collapsed');

            if ($sectionHeightContainer.length && (typeof heightAttr !== typeof undefined && heightAttr !== false && parseInt(heightAttr) > 0)) {
                mainGridSectionHeight = parseInt(heightAttr);
            }

            // related sections cases
            const facets = $currentSection.find('.facetfilters-facet-tree').length > 0;
            const facetsList = $currentSection.find('.facetfilters-list-container').length > 0;
            const promouted = $currentSection.find('.filter-set-summary__items').length > 0;
            const comments = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap').length > 0;
            const commentsInDetailBlock = $currentSection.find('.detailblock-viewcontainer .comments-wrap').length > 0;
            const halfSizeSection = $currentSection.hasClass('half-size-grid');

            // half-size section
            if (halfSizeSection) {
                const verticalOffset = self.GetElementVarticalOffset($currentSection[0]);
                const relatedHalfSizeSectionHeight = (mainGridSectionHeight / 2) - verticalOffset;
                self.setElementHeight($currentSection.find('>.xbgdecoration-wrap'), relatedHalfSizeSectionHeight);

                const $relatedGridParent = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-parent');
                if ($relatedGridParent.length > 0) {
                    const $detailSection = $relatedGridParent.closest('.xdetailssection');
                    $detailSection.css('margin-bottom', 0);
                    const $detailSectionBgElem = $relatedGridParent.closest('.xdetailssection').find('>.xbgdecoration-wrap');
                    const detailOffset = self.GetElementVarticalOffset($detailSection[0]) + self.GetElementVarticalOffset($detailSectionBgElem[0]);
                    const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container')) + 16;
                    const gridElToResize = $relatedGridParent.find('.entity-grid');
                    const $gridActionHeader = $relatedGridParent.find('.grid-action-header');
                    const gridActionHeaderHeigth = isCollapsed ? self.getHiddenElementHeight($gridActionHeader[0]) : self.getElementOuterHeight($gridActionHeader);

                    const updatedStatikGridHeigth = relatedHalfSizeSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - gridActionHeaderHeigth - dragAndDropGrid - detailOffset;
                    const gridInfo = XPortal.Grid.GetGridInfo(gridElToResize);

                    $relatedGridParent.attr('data-static-height', updatedStatikGridHeigth)
                        .addClass('static-heigth-aplied')
                        .css('margin-bottom', 0)
                        .css('height', 'auto');
                    $relatedGridParent.parent('.xcontent').removeClass('custom-scroll-vertical');
                    self.adjustParentHeight(gridElToResize, gridInfo, updatedStatikGridHeigth + 20);
                    self.setGridHeight(gridElToResize, updatedStatikGridHeigth)
                    self.resizeKGrid(gridInfo);
                }

                return
            }

            // section with setted height
            if ($currentSection.attr('data-minheight') || $currentSection.attr('data-height') || $currentSection.attr('data-maxheight')) {
                return;
            }

            // promouted filters
            if (promouted) {
                if (isCollapsed) return;
                const filterSearchHeight = self.getElementOuterHeight($currentSection.find('.dynamic-filter-summary_search'));
                const filterApplyButtonHeight = self.getElementOuterHeight($currentSection.find('.filter-set-summary > .dynamic-filter-button-wrp'));
                const filtersHeaderHeight = self.getElementOuterHeight($currentSection.find('.filter-set-summary__header'));
                const sectionBgWrapOffset = self.GetElementVarticalOffset($currentSection.find('> .xbgdecoration-wrap')[0]);
                const sectionPaddingsOfset = self.GetElementVarticalOffset($currentSection[0]);
                const totalFiltersHeight = mainGridSectionHeight - sectionHeaderHeight - filterSearchHeight - filterApplyButtonHeight - filtersHeaderHeight - sectionPaddingsOfset - sectionBgWrapOffset - 12;
                self.setElementHeight($currentSection.find('.filter-set-summary__items-scroll-container'), totalFiltersHeight)
            }

            // facet filters list
            if (facetsList) {
                const sectionPaddingsOfset = $currentSection.hasClass('remove-paddings') ? 0 : 35;
                const totalFiltersHeight = mainGridSectionHeight - sectionPaddingsOfset - sectionHeaderHeight;
                self.setElementHeight($currentSection.find('.facetfilters-list-container'), totalFiltersHeight)
            }

            //  facet filters tree
            if (facets) {
                const totalFiltersHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset;
                self.setElementHeight($currentSection.find('.facetfilters-facet-tree'), totalFiltersHeight)
            }

            // comments
            if (comments && !commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap')
                const $commentsInput = $commentsWrap.find('.comments-cntbc > .cmnt-edit-form');
                const commentsInputCalcHeight = isCollapsed ? 78 : self.getElementOuterHeight($commentsInput) + 32;
                const commentsInputHeight = $commentsInput.hasClass('cmnt-edit-form_bottom') ? commentsInputCalcHeight - 10 : commentsInputCalcHeight;
                const commentsSummaryHeight = self.getElementOuterHeight($commentsWrap.find('.comments-cntbc__summary'));
                const commentsHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - commentsInputHeight - commentsSummaryHeight;
                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setElementHeight($commentsWrap.find('.comment-items'), commentsHeight)
            }

            // comments in detail block
            if (commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('.detailblock-viewcontainer .comments-wrap');
                const detaiPageHeaderHeight = self.getElementOuterHeight($currentSection.find('.block-header_entity-detail'));
                const parentsection = $commentsWrap.closest('.xdetailssection');
                const commentsInDetailBlockSiblings = parentsection.siblings('.xdetailssection');
                const $commentsWrapSection = $commentsWrap.closest('.xsection');
                const commentsWrapSectionOffset = $commentsWrapSection.hasClass('remove-paddings') ? 2 : 48;
                const commentsHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - commentsWrapSectionOffset - detaiPageHeaderHeight;
                if (commentsInDetailBlockSiblings.length == 0) {
                    $currentSection.find('.xbgdecoration-wrap')
                        .css('height', "initial")
                        .removeClass('custom-scroll-vertical')
                        .addClass('h-100');
                    self.setElementHeight($currentSection.find('.comments-wrap'), commentsHeight)
                }
            }

            //related section with tabs
            let totalTabContentHeight = 0;
            if (withTabs) {
                const tabsNavHeight = self.getElementOuterHeight($currentSection.find('.nav-tabs'));
                $currentSection.find('> .xbgdecoration-wrap > .section-content').addClass('section-content_with-tabs')

                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setInitialHeight($currentSection.find('.filter-set-summary__items'));

                const $tabContent = $currentSection.find('.tab-content').first();
                let tabContentOffset = 0;
                let $current = $tabContent.parent();
                while ($current.length && !$current.is($currentSection)) {
                    tabContentOffset += self.GetElementVarticalOffset($current[0]);
                    $current = $current.parent();
                }

                totalTabContentHeight = mainGridSectionHeight - sectionHeaderHeight - tabsNavHeight - tabContentOffset;
                self.setElementHeight($tabContent, totalTabContentHeight);
            }

            // in case the dragAndDrop and grid in related section
            if (withRelatedGrid) {
                const $relatedGridParent = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-parent');
                const $currentSectionWrp = $currentSection.find('> .xbgdecoration-wrap');
                const $detailSection = $relatedGridParent.closest('.xdetailssection');
                const $detailSectionBgElem = $relatedGridParent.closest('.xdetailssection').find('>.xbgdecoration-wrap');
                const detailOffset = self.GetElementVarticalOffset($currentSectionWrp[0]) + self.GetElementVarticalOffset($detailSection[0]) + self.GetElementVarticalOffset($detailSectionBgElem[0]);
                const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container'));
                const tolerance = 17; //padding + border for the list view
                const gridElToResize = $relatedGridParent.find('.entity-grid');
                const $gridActionHeader = $relatedGridParent.find('.grid-action-header');
                const gridActionHeaderHeight = isCollapsed ? self.getHiddenElementHeight($gridActionHeader[0]) : self.getElementOuterHeight($gridActionHeader);

                let updatedStaticGridHeight;
                if (withTabs) {
                    updatedStaticGridHeight = totalTabContentHeight - gridActionHeaderHeight - dragAndDropGrid - tolerance - self.GetElementVarticalOffset($detailSection[0]) - self.GetElementVarticalOffset($detailSectionBgElem[0]);
                } else {
                    updatedStaticGridHeight = mainGridSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - gridActionHeaderHeight - dragAndDropGrid - detailOffset - tolerance;
                }

                const gridInfo = XPortal.Grid.GetGridInfo(gridElToResize);
                $relatedGridParent.attr('data-static-height', updatedStaticGridHeight).addClass('static-heigth-aplied');
                self.adjustParentHeight(gridElToResize, gridInfo, updatedStaticGridHeight);
                self.setGridHeight(gridElToResize, updatedStaticGridHeight);
                self.adjustListViewHeight(gridElToResize, updatedStaticGridHeight);
                self.resizeKGrid(gridInfo);
            }

            // regular related section
            if (!withTabs && !facets && !facetsList && !promouted && !comments) {
                const contentHeight = mainGridSectionHeight;
                const $sectionBgwrapper = $currentSection.find('>.xbgdecoration-wrap');
                const $sectionVerticalofset = self.GetElementVarticalOffset($currentSection[0]);
                self.setElementHeight($sectionBgwrapper, contentHeight - $sectionVerticalofset)
                // clear height for all inner sections
                $sectionBgwrapper.find('.xbgdecoration-wrap')
                    .css({ 'height': 'auto', 'overflow': 'initial' })
                    .removeClass('custom-scroll-vertical')
                    .removeClass('h-100');
            }
        },
        GetElementVarticalOffset: function (element) {
            if (!element) {
                return 0;
            }

            const computedStyle = window.getComputedStyle(element);

            const paddingTop = parseFloat(computedStyle.getPropertyValue('padding-top')) || 0;
            const paddingBottom = parseFloat(computedStyle.getPropertyValue('padding-bottom')) || 0;
            const marginTop = parseFloat(computedStyle.getPropertyValue('margin-top')) || 0;
            const marginBottom = parseFloat(computedStyle.getPropertyValue('margin-bottom')) || 0;
            const borderTopWidth = parseFloat(computedStyle.getPropertyValue('border-top-width')) || 0;
            const borderBottomWidth = parseFloat(computedStyle.getPropertyValue('border-bottom-width')) || 0;

            return paddingTop + paddingBottom + marginTop + marginBottom + borderTopWidth + borderBottomWidth;
        },
        adjustExpandCollapsePosition: function (gridEl, gridInfo) {
            if (!gridEl) gridEl = gridInfo.grid;
            if (!gridEl) return;
            if (!gridInfo) gridInfo = XPortal.Grid.GetGridInfo(gridEl);

            const $sectionWrapper = gridEl.closest('.xsection');
            const sectionHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('.block-header'));
            const sectionHeaderContainsNoTitle = $sectionWrapper.find('.block-header .no-title-subtitle').length > 0;
            const sectionHeaderNoTitle = sectionHeaderContainsNoTitle || (sectionHeaderContainsNoTitle == false && sectionHeaderHeight < 5);
            const ulbuttons = $(_.find($sectionWrapper.find('.collapse-buttons'), ui => $(ui).closest('.xsection')[0] == $sectionWrapper[0]));
            const gridHeaderHeight = self.getElementOuterHeight(gridInfo.actionsHeader);

            if (!ulbuttons || ulbuttons.length < 1 || sectionHeaderNoTitle == false || gridHeaderHeight < 5) return;
            copySectionButtonsInGrid(gridEl, gridInfo, $sectionWrapper, ulbuttons);
            showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons);
        },
        adjustGridHeaderActions: function (gridInfo, gridEl) {
            const $header = gridInfo.actionsHeader;
            const availableWidth = $header.width();
            if (availableWidth <= 0) return;
            if ($header.hasClass('quick-search-below-title'))
                $header.removeClass("quick-search-below-title");

            const minTitleWidth = 150; 
            let m = calculateHeaderMeasurements(gridInfo);
            const nonActionWidth = m.selectView + m.sidebar + m.titleOffset + m.actionsOffset + m.sidebarOffset + 20 + minTitleWidth;
            const $buttonContainer = $header.find('.grid-header-actions');
            const buttonsWidthSingle = availableWidth - (nonActionWidth + m.search);
            resizeButtons($buttonContainer, buttonsWidthSingle, m);
            const totalRequiredWidth = nonActionWidth + m.search + m.buttons + m.dots;
            const needsToWrap = totalRequiredWidth > availableWidth;

            if (needsToWrap && $buttonContainer.length) {
                const buttonsWidthWrapped = availableWidth - (m.search + 30);
                resizeButtons($buttonContainer, buttonsWidthWrapped, m);
            }

            $header.toggleClass('quick-search-below-title', needsToWrap);
            updateTitleWidth(gridInfo, needsToWrap, m);
        }
    };

    function calculateHeaderMeasurements(gridInfo) {
        const $header = gridInfo.actionsHeader;
        const $actions = $header.find('.grid-header-actions');
        const $sidebar = $header.children('.grid-header-sidebar');
        const $title = $header.children('.grid-header-title');

        const titleOuter = $title.is(':visible') ? ($title.outerWidth(true) || 0) : 0;
        const actionsOuter = $actions.is(':visible') ? ($actions.outerWidth(true) || 0) : 0;
        const sidebarOuter = $sidebar.is(':visible') ? ($sidebar.outerWidth(true) || 0) : 0;

        return {
            title: $title.find('.dd-header-wrapper').outerWidth(true) || 0,
            selectView: $title.find('.dropdown-toggle').outerWidth(true) || 0,
            sidebar: $sidebar.find('.collapse-buttons').outerWidth(true) || 0,
            search: $actions.find('.quick-search-container').outerWidth(true) || 0,
            buttons: $actions.find('.grid-buttons-inited').outerWidth(true) || 0,
            dots: Math.max($actions.find('.dots').outerWidth(true) || 0, 0),
            titleIcon: $title.find('.dd-header-wrapper__icon').outerWidth(true) || 0,

            titleOffset: Math.max(titleOuter - ($title.width() || 0), 0),
            actionsOffset: Math.max(actionsOuter - ($actions.width() || 0), 0),
            sidebarOffset: Math.max(sidebarOuter - ($sidebar.width() || 0), 0),
        };
    }
    const resizeCache = new WeakMap();
    function resizeButtons($buttonContainer, allowedWidth, m) {
        if (!$buttonContainer.parent().hasClass('grid-header-resize')) {
            $buttonContainer.parent().addClass('grid-header-resize');
        }
        const currentState = {
            width: Math.round(allowedWidth * 100) / 100,
            containerWidth: $buttonContainer.width()
        };
        const cached = resizeCache.get($buttonContainer[0]);

        if (cached && Math.abs(cached.width - currentState.width) < 2 && Math.abs(cached.containerWidth - currentState.containerWidth) < 2) {
            m.buttons = cached.buttons;
            m.dots = cached.dots;
            return;
        }

        XPortal.DropdownBtns.gridButtons.check($buttonContainer, allowedWidth);
        const $actionButtons = $buttonContainer.find('.dropdown.dropdown-hover.desktop-inline:not(.dots)');
        const $dots = $actionButtons.next('.dots');
        m.buttons = $actionButtons.outerWidth(true) || 0;
        m.dots = ($dots.length && !$dots.hasClass('d-none')) ? ($dots.outerWidth(true) || 0) : 0;
        resizeCache.set($buttonContainer[0], {
            width: currentState.width,
            containerWidth: currentState.containerWidth,
            buttons: m.buttons,
            dots: m.dots
        });
    }
    function updateTitleWidth(gridInfo, needsToWrap, m) {
        const $header = gridInfo.actionsHeader;
        const $headerContent = $header.find('.dd-header-cnt');

        if (!$headerContent.length) return;

        const hasRealContent = $headerContent
            .find('.original-title, .dd-header__subtitle')
            .filter(function () {
                const $el = $(this);
                const hasText = $.trim($el.text()).length > 0;
                const hasVisibleChildren = $el.children(':visible').length > 0;
                return hasText || hasVisibleChildren;
            })
            .length > 0;

        if (!hasRealContent) return;

        const gridWidth = $header.width();
        let availableWidth = 0;
        if (needsToWrap) {
            availableWidth = gridWidth - m.selectView - m.titleOffset - m.sidebarOffset - m.sidebar - m.titleIcon - 16;
        } else {
            const actionsRequiredWidth = m.buttons + m.dots + m.search;
            availableWidth = gridWidth - m.selectView - actionsRequiredWidth - m.actionsOffset - m.titleOffset - m.sidebarOffset - m.sidebar - m.titleIcon - 16;
        }
        const safeWidth = Math.max(availableWidth, 0);
        const titleEl = $header.find('.dd-header-wrapper')[0];
        $headerContent.css('width', 'auto');

        const naturalWidth = titleEl.scrollWidth;

        if (naturalWidth > safeWidth) {
            $headerContent.css('width', safeWidth + 'px');
        } else {
            $headerContent.css('width', 'auto');
        }
    };
    function showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons) {
        const gridBntsCntr = gridInfo.actionsHeader.find(".grid-rsbtts-wrapper");
        const isSectionCollapsed = $sectionWrapper.hasClass('collapsed');
        const isSectionMaximized = $sectionWrapper.hasClass('maximized');
        hideCollpsBtnIfMaximized(ulbuttons, gridBntsCntr, isSectionMaximized);
        let sectHeader = ulbuttons.closest(".block-header");

        if (!sectHeader.length || !$sectionWrapper.has(sectHeader)) sectHeader = ulbuttons.parent().children(".block-header");
        if (isSectionMaximized || (!isSectionCollapsed && self.isGridVisible(gridEl))) {
            gridBntsCntr.removeClass("d-none");
            sectHeader.addClass("d-none");
            ulbuttons.addClass("d-none");
            return true;
        } else {
            ulbuttons.removeClass("d-none");
            sectHeader.removeClass("d-none");
            gridBntsCntr.addClass("d-none");
            return false;
        };
    };
    function hideCollpsBtnIfMaximized(ulbuttons, gridBntsCntr, isSectionMaximized) {
        const btnCollps = gridBntsCntr.find('.collapse-buttons').find('.collapse-btn');
        if (isSectionMaximized) {
            if (btnCollps.is(":visible")) {
                btnCollps.addClass('d-none');
                btnCollps.addClass('hidden-maximized');
            }
        } else {
            if (btnCollps.hasClass("hidden-maximized")) {
                btnCollps.removeClass('d-none');
                btnCollps.removeClass('hidden-maximized');
            }
        }
    };
    function copySectionButtonsInGrid(gridEl, gridInfo, $sectionWrapper, ulbuttons) {

        const grBtnsCntnr = gridInfo.actionsHeader.find(".grid-rsbtts");
        const sctSttgsHgt = XPortal.SectionBlock.getOptions($sectionWrapper) || {};


        if (grBtnsCntnr.find(".collapse-buttons-" + sctSttgsHgt.Id).length) return;

        var copy = $("<div></div>").append(ulbuttons.clone());
        copy.addClass("collapse-buttons-" + sctSttgsHgt.Id);
        grBtnsCntnr.append(copy);

        const executeRefresh = function () {
            copy.html("");
            copy.append(ulbuttons.clone());
            copy.find(".collapse-buttons").removeClass("d-none");
            showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons);
        };
        $(document).on('click', '.collapse-buttons-' + sctSttgsHgt.Id + ' .collapse-buttons li', function (e) {
            const srcEl = $(this);
            const classNames = srcEl.attr('class');
            ulbuttons.find('li').each(function () {
                const dstEl = $(this);
                if (dstEl.attr('class') == classNames) {
                    dstEl.trigger('click');
                };
            });
            executeRefresh();
        });
        $sectionWrapper.on('expanded', executeRefresh);
        $sectionWrapper.on('collapsed', executeRefresh);
        $sectionWrapper.on('maximized', executeRefresh);
        executeRefresh();
    };

    return self;
}());
